onComplete(function () {
	const navHeader = document.querySelector('.nav-header');

	const updateHeaderHeight = () => {
		if (navHeader) {
			document.documentElement.style.setProperty(
				'--header-height',
				`${navHeader.offsetHeight}px`
			);
		}
	};

	if (navHeader) {
		updateHeaderHeight();

		new ResizeObserver(updateHeaderHeight).observe(navHeader);

		window.addEventListener('resize', updateHeaderHeight);
	};
	// fight section
	if (document.querySelector('.image-scroll-animation')) {
		gsap.to('.image-scroll-animation img', {
			clipPath: 'inset(0px 0px round 0px)',
			scrollTrigger: {
				trigger: '.image-scroll-animation',
				scrub: true,
				start: "top 40%",
				end: "center 55%",
			}
		});
	}
	// freek geluid afspelen on hover
	let audio = new Audio('static/assets/He,Freek.mp3');

	const freekBtn = document.querySelector('.freek-hero');

	freekBtn.addEventListener('click', () => {
		audio.play();
	});
});